module.exports = __webpack_public_path__ + "static/media/purepapermetal-skin-cooper-mill-finish-722-panel.9882c936.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/purepapermetal-skin-cooper-mill-finish-722-panel.jpg
// module id = 1124
// module chunks = 37